import './Logo.scss';
import React, { FC } from 'react';
import classNames from 'classnames';
import SafeLink from '@/components/extra/SafeLink/SafeLink';

type LogoProps = {
    className?: string;
    to?: string;
};

const Logo: FC<LogoProps> = ({ className, to = '/' }) => {
    return (
        <SafeLink to={to} className={classNames('Logo', className)}>
            <figure>
                <svg
                    className="Logo_img Logo_img--svg"
                    viewBox="0 0 658.83 790.83"
                    // (!) viewBox must be identical to viewBox in src/assets/images/logo-flowers.svg
                >
                    <use href="#logo-symbol" />
                </svg>
                <figcaption className="Logo_text">
                    <span className="Logo_text_a">
                        <span>Wir wollen</span>
                    </span>{' '}
                    <span className="Logo_text_b">
                        <span>wiesen</span>
                    </span>
                </figcaption>
            </figure>
        </SafeLink>
    );
};

export default Logo;
